import React from 'react'
import DeletionContent from './DeletionContent'

export default function DeletionPage () {
  return (
    <div className='deletionPage mobile'>
      <DeletionContent redirectUri='command://logout' />
    </div>
  )
}
